/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      ['Headset_M_Cube-Mesh']: Mesh
      ['Headset_M_Cube-Mesh_1']: Mesh
      ['Headset_M_Cube-Mesh_2']: Mesh
      ['Headset_M_Cube-Mesh_3']: Mesh
      ['Headset_M_Cube-Mesh_4']: Mesh
      Strap_Cube003: Mesh
    }
    materials: {
      Headset_M: MeshStandardMaterial
      Foam: MeshStandardMaterial
      Gray_Plastic: MeshStandardMaterial
      Lens: MeshStandardMaterial
      L: MeshStandardMaterial
      Strap: MeshStandardMaterial
    }
  }

export function Headset(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/headset.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Strap_Cube003.geometry}
        material={materials.Strap}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Headset_M_Cube-Mesh'].geometry}
        material={materials.Foam}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Headset_M_Cube-Mesh_1'].geometry}
        material={materials.Gray_Plastic}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Headset_M_Cube-Mesh_2'].geometry}
        material={materials.Lens}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Headset_M_Cube-Mesh_3'].geometry}
        material={materials.L}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['Headset_M_Cube-Mesh_4'].geometry}
        material={materials.Headset_M}
      />
    </group>
  )
}

useGLTF.preload('/models/headset.glb')
